import { http } from "../../../shared/api/http"

export type PurchaseRequestItem = {
  id: string
  user_id: string | null
  email: string
  phone_number: string
  telegram?: string | null
  target_type: "course"
  target_id: string
  status: "pending" | "paid" | "rejected" | "canceled"
}

export type PurchaseRequestListResponse = {
  items: PurchaseRequestItem[]
  total: number
}

export const listPurchaseRequestsApi = (
  limit = 20,
  offset = 0
) =>
  http.get<PurchaseRequestListResponse>(
    "/api/purchase-requests/",
    { params: { limit, offset } }
  )

export const updatePurchaseRequestStatusApi = (
  requestId: string,
  status: PurchaseRequestItem["status"]
) =>
  http.patch(
    `/api/purchase-requests/${requestId}/status`,
    { status }
  )
